import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { PaperPlaneTilt, Warning } from "@phosphor-icons/react";
import GuestPrivacyCard from "../components/GuestPrivacyCard";

export default function LegalPage({ endpoint, title }) {
  const [doc, setDoc] = useState({ version: "", text: "Loading…", draft_warning: "" });
  useEffect(() => { api.get(endpoint).then((r) => setDoc(r.data)); }, [endpoint]);
  const isPrivacy = endpoint.includes("privacy");
  return (
    <div className="min-h-screen bg-[#F7F6F2]">
      <header className="glass fixed top-0 left-0 right-0 z-40">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-lg bg-[#1E3A2F] flex items-center justify-center">
              <PaperPlaneTilt size={18} color="#fff" weight="fill" />
            </div>
            <span className="font-heading font-extrabold text-lg">BuzzerAI</span>
          </Link>
          <nav className="flex items-center gap-6 text-sm">
            <Link to="/terms">Terms</Link>
            <Link to="/privacy">Privacy</Link>
            <Link to="/signup" className="btn-primary text-sm">Sign up</Link>
          </nav>
        </div>
      </header>
      <section className="pt-32 pb-24 px-6">
        <div className="max-w-3xl mx-auto">
          <div className="overline mb-2">Legal · v{doc.version}</div>
          <h1 className="text-4xl mb-6">{title}</h1>

          {doc.draft_warning && (
            <div className="paper-card p-4 mb-6 bg-[#F1D7D2] border-[#A5382A]/30 flex items-start gap-3">
              <Warning size={22} color="#A5382A" weight="fill" className="flex-shrink-0 mt-0.5" />
              <div className="text-sm text-[#A5382A] leading-relaxed">
                <b>{doc.draft_warning}</b>
              </div>
            </div>
          )}

          {isPrivacy && (
            <div className="mb-6">
              <GuestPrivacyCard />
              <p className="text-xs text-[#5C6B61] mt-3 text-center">Full policy in plain lawyer-language below.</p>
            </div>
          )}

          <div className="paper-card p-8 whitespace-pre-line text-sm text-[#121914] leading-relaxed" data-testid="legal-text">
            {doc.text}
          </div>

          <p className="text-xs text-[#5C6B61] mt-6 text-center">
            Version {doc.version} · <Link to="/terms" className="underline">Terms</Link> · <Link to="/privacy" className="underline">Privacy</Link>
          </p>
        </div>
      </section>
    </div>
  );
}
